const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
// import SimpleReactValidator from 'simple-react-validator';
import CustomReactValidator from '../CustomReactValidator';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Buffer } from "buffer";

//Import Designs
import { Typography, Grid2, FormControl, TextField, FormControlLabel, Checkbox, Button, Link } from '@mui/material';
//Action to save and fetch data
import { Userlogin, GetRegister, FacebookRegister, TwitterRegister, GoogleRegister } from '../../actions/front_actions';
import ReactHtmlParser from 'react-html-parser';
import ReCAPTCHA from "react-google-recaptcha";
import FacebookLogin from '@greatsumini/react-facebook-login';

class LoginPanel extends Component {
    constructor(props) {
        super(props);
        this.state = { recaptcha: null, twitter_window: null, error_login: null };
        this.validator = new CustomReactValidator();
    }

    submitForm = () => {
        if (this.validator.allValid()) {
            const inputdata = this.state;
            this.props.Userlogin(this.props.SITE_URL, inputdata);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    componentDidMount = () => {
        this.setState({ wait: 0 })
        this.props.GetRegister(this.props.SITE_URL);
        this.setState({ wait: 1 })
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.user_login !== "undefined") {
            let user_id = nextProps.user_login.ID;
            if (typeof user_id !== "undefined") {
                window.location.reload();
            }
        }
    }

    handleValueChange = externalId => (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleResponse = (response) => {
        if (typeof response !== "undefined" && response.email) {
            this.props.FacebookRegister(this.props.SITE_URL, response);
        }
    }

    handleError = (response) => {
        console.log(response);
        // this.setState({ error_login: response.error.details });
    }

    openWindow = () => {
        var top = (window.innerHeight - 400) / 2 + window.screenY;
        var left = (window.innerWidth - 400) / 2 + window.screenX;
        let twitter_window = window.open(this.props.short.twitter_auth.twitter_url, this.props.t("twitter_signin"), "dialog=yes,top=" + top + "px,left=" + left + ",width=" + 400 + "px,height=" + 500 + "px");

        var authHandler = this.authHandler;
        window.addEventListener('message', function (event) {
            authHandler('', { oauth_token: event.data.data.oauthToken, oauth_verifier: event.data.data.oauthVerifier });
        }, false);

    };

    authHandler = (err, data) => {
        if (typeof data !== "undefined") {
            this.props.TwitterRegister(this.props.SITE_URL, { oauth_token: data.oauth_token, oauth_verifier: data.oauth_verifier, token_secret: this.props.short.twitter_auth.token_secret });
        }
    };

    responseGoogle = (response) => {
        if (response.error) {
            this.setState({ error_login: response.error.details });
            return;
        }
        //value 0 -> header, 1 -> payload, 2 -> VERIFY SIGNATURE
        const base64Payload = response.credential.split('.')[1];
        const payload = Buffer.from(base64Payload, 'base64');
        const userProfile = JSON.parse(payload);

        this.props.GoogleRegister(this.props.SITE_URL, userProfile);
    }

    onCaptchaClick = (value) => {
        this.setState({ recaptcha: value });
    }

    render() {

        const { t } = this.props;
        const { facebook_login, google_login, twitter_login, vote_fb_appid, vote_tw_appid, vote_tw_secret, vote_gg_clientid } = this.props.settings.share;
        const { vote_enable_recaptcha, vote_recapatcha_key } = this.props.settings.common;

        let error_login = '';
        if (typeof this.props.user_login !== "undefined") {
            if ((typeof this.props.user_login.errors !== "undefined")) {
                error_login = ''.concat(...Object.values(this.props.user_login.errors));
            }

            if ((typeof this.props.user_login.error !== "undefined")) {
                error_login = this.props.user_login.error;
            }
        }

        let twitter_auth_error = '';
        if (this.props.short !== undefined && this.props.short.twitter_auth?.error) {
            twitter_auth_error += this.props.short.twitter_auth.error;
        }

        const image_url = this.props.SITE_URL.replace('/wp-json/', '') + this.props.constant.PLUGIN_URL + 'assets/images/';
        return (
            (<Grid2 container className="wpvc_login_page" rowSpacing={2}>
                <Typography variant="h2">{t('you_must_logged')}</Typography>
                <Grid2 size={12}>
                    <FormControl fullWidth className="wpvc_form_control">
                        <TextField className="wpvc_text_field" type="text" name="username" label={t("login_username")} onChange={this.handleValueChange()} autoComplete="username" variant='standard' />
                    </FormControl>
                    {this.validator.message(t('username_required'), this.state.username, 'required')}
                </Grid2>
                <Grid2 size={12}>
                    <FormControl fullWidth className="wpvc_form_control">
                        <TextField className="wpvc_text_field" type="password" name="password" label={t("login_password")} onChange={this.handleValueChange()} autoComplete="current-password" variant='standard' />
                        {this.validator.message(t('password_required'), this.state.password, 'required')}
                    </FormControl>
                </Grid2>
                <Grid2 size={12}>
                    <FormControlLabel className="wpvc_form_control wpvc_login_checkbox" value="on" control={<Checkbox color="primary" name="remember_me" />} label={t("remember_me")} onChange={this.handleValueChange()} labelPlacement="end" />
                </Grid2>
                {vote_enable_recaptcha == 'on' && vote_recapatcha_key != '' &&
                    <ReCAPTCHA sitekey={vote_recapatcha_key} onChange={this.onCaptchaClick} />
                }
                {vote_enable_recaptcha == 'on' && this.validator.message(t("verify_captcha"), this.state.recaptcha, 'required')}
                <Grid2 container size={12} justifyContent="flex-start">
                    <Typography className="wpvc_error_login">{this.state.error_login ?? ReactHtmlParser(error_login)}</Typography>
                    {twitter_auth_error && <Typography className="wpvc_error_login">{twitter_auth_error}</Typography>}
                    <Button
                        variant="contained"
                        className="wpvc_login_btns"
                        color="secondary"
                        onClick={this.submitForm}
                    >{t('login_btn')}</Button>
                </Grid2>
                <Grid2 container size={12} justifyContent="flex-start">
                    <Button
                        className="wpvc_forgot_link"
                        color="primary"
                        component="a"
                        onClick={() => { this.props.handleforgot() }}
                    >
                        {t('forgot_password')}
                    </Button>
                    <Button
                        className="wpvc_forgot_link"
                        color="primary"
                        component="a"
                        onClick={() => { this.props.handleVerificationEmail(true) }}
                    >
                        {t('resend_verification_email')}
                    </Button>
                </Grid2>
                {((facebook_login == 'on' && vote_fb_appid != '') || (google_login == 'on' && vote_gg_clientid != '') || (twitter_login == 'on' && vote_tw_appid != '')) &&
                    <Grid2 size={12}>
                        <Typography variant="button">{t('login_with')}</Typography>
                    </Grid2>
                }
                <Grid2 container size={12} justifyContent="flex-start" className="wpvc_login_social_container">

                    {facebook_login == 'on' && vote_fb_appid != '' &&
                        <Grid2>
                            <FacebookLogin appId={vote_fb_appid} fields='email,first_name,last_name,name' className="wpvc_social_login_btn" onFail={this.handleError} onProfileSuccess={this.handleResponse} children={<img className="wpvc_login_social" src={image_url + 'fb_sign_in.png'} alt={t('facebook_signin')} title={t('facebook_signin')} />} />
                        </Grid2>
                    }

                    {this.props.short !== undefined && twitter_login == 'on' && this.props.short.twitter_auth?.twitter_url != '' &&
                        <Grid2 className='wpvc_twitter_signin_btn'>
                            <Link onClick={this.openWindow} >
                                <img className="wpvc_login_social" src={image_url + 'twitter_sign_in.png'} alt={t("twitter_signin")} title={t("twitter_signin")} />
                            </Link>
                        </Grid2>
                    }

                    {google_login == 'on' && vote_gg_clientid != '' &&
                        <Grid2 className="wpvc_google_login_btn">
                            <GoogleOAuthProvider clientId={vote_gg_clientid}>
                                <GoogleLogin
                                    onSuccess={this.responseGoogle}
                                    onFailure={this.responseGoogle}
                                    type="icon"
                                    theme="outline"
                                    width="80"
                                    useOneTap={true}
                                />
                            </GoogleOAuthProvider>
                        </Grid2>
                    }
                </Grid2>
            </Grid2>)
        );

    }
}

const settingstate = state => {
    return { login: state.wpvcfrontdata };
}

export default connect(settingstate, { GetRegister, Userlogin, FacebookRegister, TwitterRegister, GoogleRegister })(withTranslation("translations")(LoginPanel));
